<script>
  import Image from "../../atoms/Image.svelte";
  import Markdown from "../../atoms/Markdown.svelte";

  export let caption;
  export let altText;
  export let image;
  export let index;
  export let variant;
  export let slideItemWidth;
  export let totalSlides;

  /**
   *
   * @type {string} srcset - The srcset attribute for the image.
   */
  export let srcset = undefined;

  /**
   *
   * @type {string} sizes - The sizes of the image.
   */
  export let sizes = undefined;

  const aspectRatioClassesByVariant = {
    portrait: "aspect-3/4",
    landscape: "aspect-3/2",
    mixed: "aspect-[auto]"
  };
</script>

<div
  class="inline-block pr-7.5 align-top md:w-full md:pr-9 lg:pr-[4.5rem]"
  role="group"
  aria-roledescription="slide"
  aria-label="{index + 1} of {totalSlides}"
  style={variant !== "mixed"
    ? `min-width:${slideItemWidth}px; max-width:${slideItemWidth}px`
    : null}
>
  <Image
    src={image}
    alt={altText}
    aspectRatioClasses={aspectRatioClassesByVariant[variant]}
    elementClass={variant == "mixed" ? "md:h-[400px] lg:h-[650px] !w-auto" : null}
    {srcset}
    {sizes}
  />
  <div
    class="body-sm mt-3 flex w-[0px] min-w-full justify-between gap-x-0 whitespace-normal break-words lg:gap-x-10"
  >
    {#if caption}
      <Markdown element="span" input={caption} id="markdown-caption" />
    {/if}

    <p class="w-auto text-grey">{index + 1}/{totalSlides}</p>
  </div>
</div>
